
















import ZenyaDialog, { ZenyaDialogComponent, ZenyaDialogInjects } from "./ZenyaDialog.vue";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "ConfirmReading",
    props: {
        documentName: String
    },
    components: { ZenyaDialog },
    created() {
        //register handler for dialog OK button
        this.registerHandlers({ ok: this.ok, cancel: this.cancel });
    },
    methods: {
        openReasonDialog(): void {
            this.$emit("not-applicable");
        },

        async ok(): Promise<boolean> {
            this.$emit("ok");
            return true;
        },

        async cancel(): Promise<boolean> {
            this.$emit("cancel");
            return true;
        }
    }
});
